import { EnumDemandMotif } from 'utils/__enums/MyDemands/demandMotifs'
import EnumDemandStatus from 'utils/__enums/MyDemands/demandStatus'
import { DemandDetailHeader } from 'utils/__interfaces/MyDemands/DemandEntity'
import { EnumTypeDocumentWdh } from '../__enums/MyDocuments/TypesDocument'
import UNFOUND_DOCUMENT_TYPES from '../__consts/Documents/ListDocument'
import { CATEGORY_ADMINISTRATIVE } from '../__consts/MyDemands/DemandForms'

export default function status(
  input: string,
  date: Date | string,
  motif: string | undefined
): string {
  if (motif === EnumDemandMotif.DEVIS) {
    return EnumDemandStatus.ENVOYE
  }
  if (input === EnumDemandStatus.TRAITEE) {
    const currentDate = new Date()
    const plannedDate = new Date(date)
    plannedDate.setHours(0, 0, 0, 0)
    currentDate.setHours(0, 0, 0, 0)
    if (plannedDate >= currentDate) {
      return EnumDemandStatus.PLANIFIE
    }
  }
  if (motif === undefined) {
    return EnumDemandStatus.TRAITEE
  }
  return input
}

export const hideExpactedDate = (
  demandDetail: DemandDetailHeader | undefined
): boolean => {
  if (
    demandDetail?.category === 'Devis' &&
    (demandDetail?.motif === "Demandes d'information commerciale/offre" ||
      demandDetail?.motif === 'Réclamation commerciale' ||
      demandDetail?.motif === 'Autre')
  )
    return false

  return true
}

export const hidePlannedDate = (
  demandDetail: DemandDetailHeader | undefined
): boolean => {
  if (
    demandDetail?.category === 'Devis' &&
    demandDetail?.motif === EnumDemandMotif.DEVIS
  )
    return false

  return true
}

export const isUnfoundDocument = (ccapDetail: string): boolean => {
  return Object.values(EnumTypeDocumentWdh).some(
    (docType) =>
      ccapDetail === UNFOUND_DOCUMENT_TYPES[docType] ||
      ccapDetail === CATEGORY_ADMINISTRATIVE
  )
}
